export default "__VITE_ASSET__DUvHfIYu__"